export default "__VITE_ASSET__C6zGPf1D__"